import { Candidate, Group, Page, PageRequest } from '$synapse/models';
import { CandidateService } from '$synapse/services';
import {
  Component,
  ElementRef,
  OnInit,
  inject,
  input,
  output,
  viewChild,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import {
  Observable,
  debounceTime,
  first,
  map,
  startWith,
  switchMap,
} from 'rxjs';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { SHARED_IMPORTS } from '../../shared-imports';

@Component({
  selector: 'syn-candidate-picker',
  templateUrl: './candidate-picker.component.html',
  imports: [SHARED_IMPORTS],
})
export class CandidatePickerComponent implements OnInit {
  private readonly _candidateService = inject(CandidateService);

  readonly group = input<Group>(undefined);

  readonly addCandidate = output<string[]>();

  readonly candidateInput =
    viewChild<ElementRef<HTMLInputElement>>('candidateInput');
  CandidateCtrl = new UntypedFormControl('');
  _delayTimeMs = 300;

  selectedCandidates: Candidate[] = [];
  filteredCandidates: Observable<Candidate[]>;

  ngOnInit(): void {
    this.filteredCandidates = this.CandidateCtrl.valueChanges.pipe(
      startWith(''),
      debounceTime(this._delayTimeMs),
      switchMap((candidate) => this._search(candidate)),
      map((page: Page<Candidate>) =>
        page.content.filter(
          (candidate) =>
            !this.selectedCandidates
              .map((candidate) => candidate.id)
              .includes(candidate.id)
        )
      )
    );
  }

  remove(candidate: Candidate): void {
    const index = this.selectedCandidates.indexOf(candidate);

    if (index >= 0) {
      this.selectedCandidates.splice(index, 1);
    }
    if (this.selectedCandidates.length == 0) {
      this.addCandidate.emit([]);
    }
    this.CandidateCtrl.setValue(null);
  }

  candidateSelected(event: MatAutocompleteSelectedEvent): void {
    const candidate: Candidate = event.option.value;
    this.selectedCandidates.push(candidate);
    this.candidateInput().nativeElement.value = '';
    this.CandidateCtrl.setValue(null);

    this.addCandidate.emit(this.selectedCandidates.map((c) => c.id));
  }

  private _search(filter: string): Observable<Page<Candidate>> {
    const search = filter || '';

    let page: PageRequest = new PageRequest({
      search: search,
    });

    return this._candidateService.findAll(page).pipe(first());
  }
}
